<template>
  <div>
    <a-modal
      v-model="isLimitDialogShow"
      :title="editQuota"
      on-ok="handleOk"
      width="458px"
      :mask-closable="false"
      wrap-class-name="filter-modal-group"
      @cancel="handleCancel"
    >
      <div>
        <div class="alert-blue-title">
          {{ $t('message["1145"]') }}。
        </div>
        <div>
          <a-form
            :form="form"
            @submit.prevent="handleSubmit"
          >
            <div
              v-if="members.length"
              class="main-content-div"
            >
              <a-form-item
                v-for="(item,indexs) in members"
                :key="item.uesrid"
                :label="item.truename"
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
                class="form-item"
              >
                <a-input
                  v-decorator="[`limitLists[${indexs}]`,{validateTrigger: ['change', 'blur'],rules: [{ required: true, message: '',validator: checkGroupName}]}]"
                  :placeholder="limitNumbPlace"
                  class="number-input"
                  max-length="25"
                />
              </a-form-item>
            </div>
          </a-form>
        </div>
      </div>
      <template slot="footer">
        <a-button
          key="back"
          @click="handleCancel"
        >
          {{ $t('message["896"]') }}
        </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="groupLeaderEditSaveLoading"
          @click="handleSubmit"
        >
          {{ $t('message["915"]') }}
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    itemData: {
      type: Object,
      default () {
      }
    }
  },
  data () {
    return {
      members: [],
      defaultValues: [],
      isLimitDialogShow: false,
      inputLength: 0,
      visible: false,
      subData: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      limitListLocal: [],
      form: this.$form.createForm(this)
    }
  },
  computed: {
    ...mapState('team/group', ['editGroupSet', 'divideObj', 'groupLeaderEditVisible', 'groupEditLimitVisible', 'groupMemberLeaderList', 'groupMemberList', 'groupLeaderEditSaveLoading']),
    editQuota () {
      return this.$t('message["39"]')
    },
    limitNumbPlace () {
      return this.$t('message["838"]')
    }
  },
  watch: {
    isLimitDialogShow (val) {
      if (!val) return
      // let vvs = JSON.parse(JSON.stringify(this.itemData.members))
      let vvs = this.itemData.member.list
      // console.log(this.itemData.member.list)
      this.limitListLocal = []
      vvs.map((value, indexvvs) => {
        value.divide_number = ''
        this.limitListLocal[indexvvs] = ''
        if (this.itemData.divide_desc) {
          if (Array.isArray(this.itemData.divide_desc)) {
            this.itemData.divide_desc.map(values => {
              if (value.userid === values.userid) {
                value.divide_number = values.divide_number
                this.limitListLocal[indexvvs] = values.divide_number * 1
              }
            })
          }
        }
      })
      this.members = vvs
      setTimeout(() => {
        this.form.setFieldsValue({ limitLists: this.limitListLocal })
      }, 200)
    }
    // isLimitDialogShow (val) {
    //   if (val) {
    //     setTimeout(() => {
    //       this.form.setFieldsValue({ limitLists: this.limitListLocal })
    //     }, 200)
    //   }
    // }
  },
  methods: {
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    // 自定义校验额度分配方法
    checkGroupName (rule, value, callback) {
      if (value === '') {
        this.inputLength = 0
        callback(new Error(this.$t('message["766"]')))
        return false
      }
      if (!(/(^[0-9]\d*$)/.test(value))) {
        callback(new Error(this.$t('message["838"]')))
        return false
      }
      callback()
    },
    // 表单提交
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, data) => {
        if (!err) {
          this.$emit('getLimitData', this.getDivide_desc(this.members, data.limitLists))
          this.isLimitDialogShow = false
        }
      })
    },
    // 添加小组---取消操作
    handleCancel (e) {
      this.isLimitDialogShow = false
    },
    getDivide_desc (array, data) {
      let val = []
      array.map((value, index) => {
        val.push({ userid: value.userid, divide_number: data[index] * 1 })
      })
      return val
    }
  }
}
</script>
<style lang="scss">
.filter-modal-group {
  .ant-modal-header {
    border-bottom: none;
    height: 56px;
  }
  .ant-modal-title {
    font-size: 18px;
    font-weight: 600;
    height: 56px;
    line-height: 56px;
    color: #333333;
  }
}
.main-content-div {
  .ant-form-item-control {
    .ant-form-explain {
      // margin-left: 52px;
    }
  }
}
</style>

<style lang="scss" scoped>
.dialog-title-section {
  margin-bottom: 25px;
  font-size: 20px;
  span {
    margin-left: 10px;
  }
}
.alert-blue-title {
  background-color: #e8f4ff;
  color: #333;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  padding-left: 24px;
  margin: 0 -24px 32px
}
.input-main {
  width: 100%;
}
.main-content-div {
  max-height: 392px;
  width: 412px;
  overflow: auto;
  // margin-left: -24px;
}
/* .main-content-div::-webkit-scrollbar {
  width: 8px;
  height: 20px;
  border-radius: 4px;
}
.main-content-div::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #ebebeb;
}
.main-content-div::-webkit-scrollbar-track {
  border-radius: 0;
  background: #fff;
} */
.number-input {
  width: 240px;
  outline: none;
  //margin-left: 52px;
}
.form-item::v-deep {
  height: 32px;
  margin-bottom: 16px;
  .ant-form-item-label {
    text-overflow: ellipsis;
  }
}
.s-info {
  color: #c0c4cc;
  margin-left: 5px;
}
.search-select {
  width: 450px;
  margin: 0 auto;
}
.username {
  display: inline-block;
  width: 120px;
}
</style>
